export interface Application {
  appId: string
  displayName: string
  snowAccountId: string
  permissions: ApplicationPermission[]
  passwordCredentials: ApplicationCredential[]
}

export interface ApplicationCredential {
  keyId: string
  displayName: string
  hint: string
  secretText: string
  endDateTime: string
}

export enum ApplicationPermission {
  TicketsReadWrite = 'Tickets.ReadWrite',
  ContactsReadWrite = 'Contacts.ReadWrite'
}
